class FreeGiftProgress extends HTMLElement {
  connectedCallback() {
    this.addButton = this.querySelector('[data-gift-add-btn]');
    
    if (this.addButton) {
      // Listener wird erst gebunden, wenn das Element sicher im DOM montiert ist
      this.addButton.addEventListener('click', this.addGiftToCart.bind(this));
    }
  }

  async addGiftToCart(event) {
    event.preventDefault();

    // Dynamisches Auslesen der Variant ID (vom Button oder Container Element)
    const variantId = this.addButton?.dataset.variantId || this.dataset.variantId;

    if (!variantId) {
      console.error('FreeGiftProgress: Keine Variant-ID gefunden.');
      return;
    }

    this.setLoadingState(true);

    try {
      // 1. Geschenk hinzufügen UND Sections in EINEM Request vom Shopify Server anfordern
      const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
        method: 'POST',
        headers: { 
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          items: [{
            id: parseInt(variantId, 10),
            quantity: 1
          }],
          sections: ['cart-drawer', 'cart-icon-bubble']
        })
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.description || 'Fehler beim Hinzufügen');
      }

      const parsedState = await response.json();

      // 2. Bestehenden Cart Drawer über die native renderContents Methode re-rendern
      const cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
        cartDrawer.renderContents(parsedState);
      } else {
        window.location.reload();
      }

    } catch (error) {
      console.error('Fehler beim Hinzufügen des Geschenks:', error);
      this.setLoadingState(false);
    }
  }

  setLoadingState(isLoading) {
    if (!this.addButton) return;
    const btnText = this.addButton.querySelector('.btn-text');
    const btnSpinner = this.addButton.querySelector('.btn-spinner');

    if (isLoading) {
      this.addButton.setAttribute('disabled', 'true');
      btnText?.classList.add('hidden');
      btnSpinner?.classList.remove('hidden');
    } else {
      this.addButton.removeAttribute('disabled');
      btnText?.classList.remove('hidden');
      btnSpinner?.classList.add('hidden');
    }
  }
}

customElements.define('free-gift-progress', FreeGiftProgress);